import styled from '@mui/system/styled';

const Img = styled('img')({
  width: '45px',
  marginRight: '10px',
});

export default Img;
